import styled from 'styled-components';
import rightArrow from '../../images/policy/right-arrow.svg';
import OpdBackground from '../../images/newInsurerPage/OpdBg.svg';
import GmcBackground from '../../images/newInsurerPage/GmcBg.svg';
import ClaimsCardIconBackground from '../../images/newInsurerPage/claimscardiconBackground.svg';
import ClaimsCardIcon from '../../images/newInsurerPage/claimsCardIcon.svg';
import blueArrow from '../../images/newInsurerPage/blueArrow.svg';
import ClaimCardBg from '../../images/newInsurerPage/claimCardBg.svg';
import Tappable from 'react-tappable/lib/Tappable';

const CardBody = styled.div`
  display: flex;
  //   justify-content: space-evenly;
  align-items: center;
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  text-align: center;
  border: ${(props) => (props.borderColor ? '1px solid' : 'none')};
  border-image: ${(props) =>
    props.borderColor ? `${props.borderColor}` : 'none'};
  border-radius: 12px;
  padding: 15px 28px 15px 20px;
  margin-bottom: 1rem;
`;

const CardIcon = styled.img`
  // align-self: flex-start;
  padding: 7px;
`;
const CardIconContainer = styled.div`
  display: flex;
  align-self: flex-start;
  height: 40px;
  width: 40px;
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`};
`;

const CardDetails = styled.div`
  padding: 0px 18px 0px 20px;
  text-align: left;
  flex: 1;
`;

const CardTitle = styled.p`
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
  white-space: pre-wrap;
  margin-bottom: 4px;
  color: #004fe8;
`;

const CardSubtitle = styled.p`
  color: #171616;
  font-size: 10px;
  font-weight: 500;
  line-height: 15px;
  white-space: pre-wrap;
  color: ${(props) => props.titleColor};
`;

const RightArrow = styled.img`
  filter: ${(props) => (props.filter ? `${props.filter}` : 'none')};
`;

const getBackgroundColor = (ThemeKey) => {
  switch (ThemeKey) {
    case 'my-claims':
      return '#CDF';
    default:
      return '';
  }
};

// const getArrow = (ThemeKey) => {
//   switch (ThemeKey) {
//     case 'claims':
//       return blueArrow;
//     default:
//       return '';
//   }
// };

const NewClaimsCard = (props) => {
  return (
    <Tappable onTap={props.onTap}>
      <CardBody
        bgSvg={ClaimCardBg}
        borderColor=""
        bgColor={getBackgroundColor(props.data.themeKey)}
      >
        <CardIconContainer bgSvg={ClaimsCardIconBackground} bgColor="#CDF">
          <CardIcon src={ClaimsCardIcon} alt="icon" />
        </CardIconContainer>

        <CardDetails>
          <CardTitle style={{ whiteSpace: 'pre' }}>
            {props.data.title}
          </CardTitle>
          <CardSubtitle>{props.data.subTitle}</CardSubtitle>
        </CardDetails>
        <RightArrow src={blueArrow} filter={props.filter} />
      </CardBody>
    </Tappable>
  );
};

export default NewClaimsCard;
